<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <div v-if="errormessage">
        <v-alert
          dismissible
          v-model="errormessage"
          dense
          outlined
          type="error"
          >{{ errormessage }}</v-alert
        >
      </div>

      <v-toolbar>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in tabitems" :key="item.index">
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabitems" :key="item.index">
          <v-card flat>
            <v-data-table
              :headers="headers"
              :items="item.data"
              item-value="Doc_No"
            >
              <template v-slot:item="{ item }">
                <tr :key="item.Doc_No">
                  <td>{{ item.insertdate | toDate }}</td>
                  <td>{{ item.Doc_No }}</td>
                  <td>{{ item.CustCode }} - {{ item.CustName }}</td>
                  <td class="number">{{ item.Amount | numberFormat }}</td>
                  <td class="number">{{ item.Discount | numberFormat }}</td>
                  <td class="number">
                    {{ item.Total | numberFormat }}
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      @click.stop="
                        getData(
                          item.Doc_No,
                          item.CustCode,
                          item.CustName,
                          item.OrdPending
                        )
                      "
                    >
                      View
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog v-model="dialog">
        <v-card v-model="order">
          <v-list-item three-line v-if="order.length > 0">
            <v-list-item-content>
              <div class="overline mb-4">
                Order Details<v-spacer></v-spacer>
                <v-btn @click="exportCsv()">Export csv</v-btn>
              </div>
              <v-list-item-title class="headline mb-1">
                Document NO : {{ order[0].Doc_No }}
              </v-list-item-title>
              <v-list-item-subtitle
                ><span v-if="order[0].UserName"
                  >Order created by : {{ order[0].UserName }} </span
                ><br />
                <span v-if="Customer">Customer : {{ Customer }}</span>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-card-text>
            <v-data-table :headers="orderFields" :items="order" item-value="Ln">
              <template v-slot:item="{ item }">
                <tr>
                  <td>{{ item.Ln }}</td>
                  <td>{{ item.Prod_Code }} - {{ item.Prod_Name }}</td>
                  <td class="number">{{ item.Purch_Price | numberFormat }}</td>
                  <td class="number">
                    {{ item.Selling_Price | numberFormat }}
                  </td>
                  <td class="number">{{ item.Qty }}</td>
                  <td class="number">{{ item.FreeQty }}</td>
                  <td class="number">{{ item.Amount | numberFormat }}</td>
                  <td class="number">{{ item.Discount | numberFormat }}</td>
                  <td class="number">
                    {{ (item.Amount - item.Discount) | numberFormat }}
                  </td>
                </tr>
              </template>
              <template slot="body.append">
                <tr>
                  <th colspan="4" class="number large">Totals</th>
                  <th class="number large">{{ sumField("Qty") }}</th>
                  <th class="number large">{{ sumField("FreeQty") }}</th>
                  <th class="number large">
                    {{ sumField("Amount") | numberFormat }}
                  </th>
                  <th class="number large">
                    {{ sumField("Discount") | numberFormat }}
                  </th>
                  <th class="number large">
                    {{
                      (sumField("Amount") - sumField("Discount")) | numberFormat
                    }}
                  </th>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="red darken-1" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn
              v-if="isPendingOrder"
              color="green darken-1"
              text
              @click="setOrderState(2)"
            >
              Cancel Order
            </v-btn>
            <v-btn
              v-if="isPendingOrder"
              color="green darken-1"
              text
              @click="setOrderState(1)"
            >
              Complete Order
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import moment from "moment";
var numeral = require("numeral");
import { HTTP, setAuthToken, BASE_URL } from "../../../lib/http.common";
let userActivityTimeout = null;
let INACTIVE_USER_TIME_THRESHOLD = 1000 * 60;
let isactive = false;
//import sql from 'mssql'
export default {
  name: "Orders",
  computed: {},
  components: {},
  filters: {
    toDate(value) {
      if (value) {
        //console.log(value);
        //console.log(moment(value).utcOffset('+0530').format('YYYY-MM-DD hh:mm:ss'));
        return moment(value.replace("T", " ").replace("Z", " "))
          .utcOffset("+0530")
          .format("YYYY-MM-DD hh:mm a");
      }
    },
    numberFormat(v) {
      //if (v) {
      return numeral(v).format("0,0.00");
      // }
    },
  },
  methods: {
    exportCsv() {
      let csv = [];
      let columns = [
        "Ln,Code,Product Name,Cost,Selling,Qty,Free qty,Amount,Discount,Sub Total",
      ];
      let orderdetails =
        "Order No :," +
        this.order[0].Doc_No +
        "\r\n" +
        "Order Rep/User :," +
        this.order[0].UserName +
        "\r\n" +
        "Customer :," +
        this.Customer +
        "\r\n";
      csv.push(orderdetails);
      /*
      this.orderFields.forEach((h) => {
        columns.push(h.text);
      });*/
      csv.push(columns.join(","));

      this.order.forEach((row) => {
        let c = [];
        c.push(row.Ln);
        c.push(row.Prod_Code);
        c.push(row.Prod_Name);
        c.push(row.Purch_Price);
        c.push(row.Selling_Price);
        c.push(row.Qty);
        c.push(row.FreeQty);
        c.push(row.Amount);
        c.push(row.Discount);
        c.push(row.Amount - row.Discount);
        csv.push(c.join(","));
      });

      let sum = [0, 0, 0, 0, 0];

      this.order.forEach((row) => {
        sum[0] += row.Qty;
        sum[1] += row.FreeQty;
        sum[2] += row.Amount;
        sum[3] += row.Discount;
        sum[4] += row.Amount - row.Discount;
      });
      csv.push(",,,,Total :," + sum.join(","));
      console.log(csv);

      const anchor = document.createElement("a");
      anchor.href =
        "data:text/csv;charset=utf-8," + encodeURIComponent(csv.join("\r\n"));
      anchor.target = "_blank";
      anchor.download = this.order[0].Doc_No + "_" + this.Customer + ".csv";
      anchor.click();
    },
    resetUserActivityTimeout() {
      isactive = true;
      clearTimeout(userActivityTimeout);
      userActivityTimeout = setTimeout(() => {
        isactive = false;
      }, INACTIVE_USER_TIME_THRESHOLD);
    },

    get() {
      this.timer = setInterval(() => {
        if (isactive) this.getOrders();
      }, 1000);
    },

    setOrderState(state) {
      var doc = this.order[0].Doc_No;
      HTTP.post(BASE_URL + `orders/org/set/` + doc + "/" + state)
        .then((response) => {
          this.order = response.data[0].dataset;
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            this.errormessage = response.data[0].message;
          } else {
            if (!response.data[0].season) this.$router.push("/login");

            this.dialog = false;
            this.errormessage = null;                              
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },
    getData(doc, c, co, p) {
      this.isPendingOrder = p;
      this.Customer = c + "-" + co;
      HTTP.get(BASE_URL + `orders/org/one/` + doc)
        .then((response) => {
          this.order = response.data[0].dataset.Items;
          this.ordersummery = response.data[0].dataset.OrderSummery;
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.dialog = true;
            this.errormessage = null;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },
    getOrders() {
      HTTP.get(BASE_URL + `orders/org/all/` + this.filter)
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            var data = response.data[0].dataset;
            this.tabitems[0].data = [];
            this.tabitems[1].data = [];
            this.tabitems[2].data = [];
            data.forEach((row) => {
              if (row.OrdPending === true) this.tabitems[0].data.push(row);
              else if (row.OrdComplete === true)
                this.tabitems[1].data.push(row);
              else if (row.Canceled === true) this.tabitems[2].data.push(row);
            });
          }
          this.overlay = false;
        })
        .catch((e) => {
          this.errormessage = e;
          this.overlay = false;
        });
    },
    sumField(key) {
      // sum data in give key (property)
      return this.order.reduce((a, b) => a + (b[key] || 0), 0);
    },
  },

  beforeCreate() {
    setAuthToken();
  },
  mounted() {
    window.addEventListener("mousemove", this.resetUserActivityTimeout);
    window.addEventListener("scroll", this.resetUserActivityTimeout);
    window.addEventListener("keydown", this.resetUserActivityTimeout);
    window.addEventListener("resize", this.resetUserActivityTimeout);
    this.get();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    clearInterval(userActivityTimeout);
  },

  data() {
    return {
      completedata: [],
      canceleddata: [],
      pendingdata: [],
      ordersummery: {},
      overlay: true,
      csvdataset: [],
      name: "ORDER MANAGEMENT",
      tab: null,
      tabitems: [
        { name: "New orders", index: 0, data: [] },
        { name: "Completed orders", index: 1, data: [] },
        { name: "Canceled Orders", index: 2, data: [] },
      ],
      Customer: "",
      dialog: false,
      current: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, { value: 100, text: "Show a lot" }],
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      posts: [],
      error: false,
      errormessage: null,
      data: [],
      order: [],
      isPendingOrder: false,
      headers: [
        {
          value: "insertdate",
          text: "Date",
          sortable: true,
        },
        {
          value: "Doc_No",
          text: "Document",
          sortable: true,
        },
        {
          value: "CustCode",
          text: "Customer",
          sortable: true,
        },

        {
          value: "Amount",
          text: "Gross Amount",
          sortable: false,
          align: "right",
        },
        {
          value: "Discount",
          text: "Discount Amount",
          sortable: false,
          align: "right",
        },
        {
          value: "Total",
          text: "Sub Total",
          sortable: false,
          align: "right",
        },
        { value: "actions", text: "Actions" },
      ],
      orderFields: [
        {
          value: "Ln",
          text: "#",
          sortable: true,
        },
        {
          value: "Prod_Code",
          text: "Product",
          sortable: true,
        },
        {
          value: "Purch_Price",
          text: "Cost",
          align: "right",
        },
        {
          value: "Selling_Price",
          text: "Selling",
          align: "right",
        },
        {
          value: "Qty",
          text: "Qty",
          align: "right",
        },
        {
          value: "FreeQty",
          text: "Free Qty",
          align: "right",
        },
        {
          value: "Gross Amount",
          text: "Amount",
          align: "right",
        },
        {
          value: "Discount",
          text: "Discount",
          align: "right",
        },
        {
          value: "Total",
          text: "Sub Total",
          align: "right",
        },
      ],
      timer: undefined,
    };
  },
};
</script>


<style scoped>
.modal {
  justify-content: center;
  align-items: center;
  width: 900px;
}
.modal-open .modal {
  z-index: 1050;
}
.card-body {
  color: #fff;
  background: #3e3e3e;
}
.refresh {
  margin: 15px;
}

.number {
  text-align: end !important;
}
.large {
  font-size: large !important;
}
.overline {
  display: inline-flex;
}
</style>


